import * as React from 'react'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import { Auth_logout } from './Auth.logout'
import { DS_getData, DS_setData } from '../DS/DS.Data'
import { DS_Listen } from '../DS/DS.ui.Listen'
import { UI_dialogOpen } from '../UI/UI.Dialog'
import { Translations } from '../../../shared/i18n/Translations'

export async function Auth_forceLogout() {
    const labelStyle = { color: 'var(--red)' }
    if (DS_getData().forcedLogoutCanLogoutWithoutWarning) {
        Auth_logout()
        return
    }

    // Show a dialog box
    UI_dialogOpen(
        {
            title: <p style={labelStyle}>{Translations.t('app:User.forcedLogoutHeading')}</p>,
            modal: true,
            onRequestClose: null,
        },
        DS_Listen(
            (d) => ({ count: d.forcedLogoutCount }),
            ({ count }) => <p>{Translations.t('app:User.forcedLogoutMessage', [count])}</p>
        )
    )

    // Countdown from 5
    for (let i = 5; i > 0; i--) {
        DS_setData('ForcedLogoutCountdown', () => ({ forcedLogoutCount: i }))
        await timeout(1000)
    }

    // Then log the user out
    Auth_logout()
}
